export async function requestMetaDescription (uid, requestIdent, requestTitle, selectedLanguage) {
    const formData = new FormData();
    formData.append("uid", uid)
    formData.append("ident", requestIdent)
    formData.append("title", requestTitle)
    formData.append("language", selectedLanguage)
    const response = await fetch('./requests/meta-description.php', {
      method: 'POST',
      //headers: {
      //  'Content-type': 'text/html'
      //},
      body: formData
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.text();
    //console.log('Generated content:', data);
    return {__html: data}
  }
